<template>
  <v-dialog
      :value="show"
      fullscreen
      persistent
      scrollable
      hide-overlay
      transition="dialog-bottom-transition"
  >
    <v-card>

      <v-card-title class="primary white--text">
        <v-icon color="white" class="mr-2" @click="$emit('close')">mdi-close</v-icon>
        <div class="title">Etiquetas</div>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed :disabled="disable" @click="syncLabels" :loading="saving">
          <v-icon class="mr-1">mdi-save</v-icon>
          Guardar
        </v-btn>
      </v-card-title>

      <v-card-text class="py-4">
        <v-row class="pt-4">
          <v-col cols="12" md="8" offset-md="1" lg="6" offset-lg="3">
            <v-row>
              <v-col cols="12">
                <label-picker
                    v-if="show"
                    outlined
                    type="event"
                    :disable-creation="!currentProviderSettings.allow_label_creation"
                    @change="currentLabels = $event"
                    :value="labels"
                />
              </v-col>
              <v-col cols="12" class="text-center">
                <label-history
                    v-if="history && history.length > 0"
                    :history="history"
                />
                <span v-else>Aún no se han agregado etiquetas</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import LabelPicker from "@/components/common/LabelPicker";
import LabelHistory from "@/components/appointments/details/LabelHistory";
import {ApiUtils} from "@/utils/ApiUtils";
import ProviderSettingsMixin from "@/mixins/ProviderSettingsMixin";


export default {
  name: "LabelsDetailsDialog",
  components: {LabelHistory, LabelPicker},
  mixins: [ProviderSettingsMixin],
  props: {
    eventId: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Array,
      required: true
    },
    history: {
      type: Array,
      required: true
    }
  },
  data(){
    return {
      currentLabels: [],
      saving: false,
      disable: true
    }
  },
  methods: {
    async syncLabels(){

      const vm = this
      if(vm.saving || !vm.currentProvider || !vm.scheduleEventId) return
      vm.saving = true
      const labelIds = vm.currentLabels.map(lbl => lbl.id)
      const url = `appointments/${vm.scheduleEventId}/labels`
      const response = await ApiUtils.makePatch(url, null, {
        labels: labelIds
      })
      vm.saving = false
      if(!response.ok){
        return vm.toast('Ocurrió un error intentando guardar', 'error')
      }

      vm.toast('Etiquetas guardadas correctamente')
      vm.disable = true
      vm.$emit('change', vm.currentLabels)

    }
  },
  computed:{
    scheduleEventId(){
      const vm = this
      if(vm.eventId) return vm.eventId

      return vm.history && vm.history.length > 0 ?
          vm.history[0].schedule_event_id : null

    }
  },
  watch:{
    show(val){
      const vm = this
      if(val) {
        vm.disable = true
      }
    },
    currentLabels(val){
      if(val) this.disable = false
    }
  }
}
</script>

<style scoped>

</style>
